'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSize = void 0;
var ModalSize;
(function (ModalSize) {
    ModalSize["DEFAULT"] = "small";
    ModalSize["LARGE"] = "large";
    ModalSize["MOBILE_OVERLAY"] = "mobile-overlay";
    ModalSize["BORDERLESS"] = "borderless";
})(ModalSize = exports.ModalSize || (exports.ModalSize = {}));
